/** @format */
import {ChangeEvent, useEffect, useState} from 'react';

import {Box, Grid2 as Grid, Typography} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import PrimaryMediumButton from 'components/buttons/PrimaryMediumButton';
import MediumTextField from 'components/inputs/MediumTextField';
import SecondarySelect from 'components/selects/SecondarySelect';
import {fieldName} from 'helpers/field_names';
import {Operator} from 'types';

import {
  DATE_FIELDS,
  DATE_OPERATORS,
  MATH_OPERATORS,
  NUMBER_FIELDS,
  TEXT_OPERATORS,
} from './constants';

type Props = {
  field: string;
  value?: string;
  onSave: (field: string, operator: Operator, value: string) => void;
};

export const ExceptionForm = (props: Props) => {
  const [operator, setOperator] = useState(TEXT_OPERATORS[0]);
  const [valueInputType, setValueInputType] = useState('text');
  const [value, setValue] = useState(props.value || '');
  const [operators, setOperators] = useState(TEXT_OPERATORS);
  const {t} = useTranslation();

  useEffect(() => {
    if (NUMBER_FIELDS.includes(props.field)) {
      setOperators(MATH_OPERATORS);
      setValueInputType('number');
    } else if (DATE_FIELDS.includes(props.field)) {
      setOperators(DATE_OPERATORS);
      setValueInputType('date');
    } else {
      setValueInputType('text');
    }
  }, [props.field]);

  const options = operators.map(v => ({
    value: v,
    text: t(`operators.${v}`),
  }));

  const handleSelectOperator = (value: string) => {
    setOperator(value as Operator);
  };

  const handleChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const handleClick = () => {
    props.onSave(props.field, operator, value);
  };

  return (
    <Box
      sx={{
        pt: 8,
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          alignItems: 'center',
        }}
      >
        <Grid size={{xs: 6, sm: 3}}>
          <Typography variant='body1'>{t(fieldName(props.field))}</Typography>
        </Grid>
        <Grid size={{xs: 6, sm: 5}}>
          <SecondarySelect
            options={options}
            width={170}
            value={operator}
            onSelect={handleSelectOperator}
          />
        </Grid>
        <Grid size={{xs: 12, sm: 4}}>
          <MediumTextField
            value={value}
            type={valueInputType}
            required
            slotProps={{
              htmlInput: {
                'aria-label': 'exception-value-input',
              },
            }}
            onChange={handleChangeValue}
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          mt: 9,
        }}
      >
        <PrimaryMediumButton disabled={value == ''} onClick={handleClick}>
          <Trans>Сохранить</Trans>
        </PrimaryMediumButton>
      </Box>
    </Box>
  );
};
